import { Box, Typography } from "@mui/material";

const POSTER_URL =
  "https://cdn.prod.website-files.com/674fa7a7386e9849d64aca65%2F675a4068792c1673225a802e_closeup-football-dribbling-in-slow-motion-in-an-un-2023-11-27-05-04-22-utc_2-poster-00001.jpg";
const VIDEO_MP4_URL =
  "https://cdn.prod.website-files.com/674fa7a7386e9849d64aca65%2F675a4068792c1673225a802e_closeup-football-dribbling-in-slow-motion-in-an-un-2023-11-27-05-04-22-utc_2-transcode.mp4";
const VIDEO_WEBM_URL =
  "https://cdn.prod.website-files.com/674fa7a7386e9849d64aca65%2F675a4068792c1673225a802e_closeup-football-dribbling-in-slow-motion-in-an-un-2023-11-27-05-04-22-utc_2-transcode.webm";

const Hero = () => {
  return (
    <Box
      sx={{
        height: "100vh",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
        component="video"
        autoPlay
        loop
        muted
        playsInline
        poster={POSTER_URL}
        sx={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          position: "absolute",
          top: 0,
          left: 0,
        }}
      >
        <source src={VIDEO_MP4_URL} type="video/mp4" />
        <source src={VIDEO_WEBM_URL} type="video/webm" />
      </Box>
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "#000000b3",
          zIndex: 1,
        }}
      />
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 2,
          textAlign: "center",
          width: "100%",
          maxWidth: "1200px",
          px: 3,
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontWeight: 800,
            fontSize: { xs: "2.5rem", sm: "3.5rem", md: "4.5rem", lg: "5.5rem" },
            lineHeight: 1.1,
            color: "#ffffff",
            mb: 3,
            textShadow: "0 4px 20px rgba(0, 0, 0, 0.5)",
            letterSpacing: "-0.02em",
            fontFamily: "HeadingNowVarTrial, Montserrat, sans-serif",
            textTransform: "uppercase",
          }}
        >
          AI That Transforms How Football Entities Build Their Future
        </Typography>
        <Typography
          variant="h2"
          sx={{
            fontWeight: 600,
            fontSize: { xs: "1.25rem", sm: "1.5rem", md: "1.75rem", lg: "2rem" },
            lineHeight: 1.4,
            color: "#ffffff",
            textShadow: "0 2px 10px rgba(0, 0, 0, 0.5)",
            maxWidth: "900px",
            mx: "auto",
            fontFamily: "Montserrat, sans-serif",
          }}
        >
          From seamless management to next-level scouting—unlock talent before the world sees it.
        </Typography>
      </Box>
    </Box>
  );
};

export default Hero;
